module.exports = {
  储值中心: '储值中心',
  角色信息: '角色信息',
  '角色：': '角色：',
  '区服：': '区服：',
  '游戏：': '游戏：',
  '商品：': '商品：',
  支付方式: '支付方式',
  '结算：': '结算：',
  '订单金额：': '订单金额：',
  '支付金额：': '支付金额：',
  确认支付: '确认支付',
  请选择支付方式: '请选择支付方式',
  '注意：支付金额请以实际支付时为准': '注意：支付金额请以实际支付时为准',
  '订单号：': '订单号：',
  '时间：': '时间：',
  '支付方式：': '支付方式：',
  '钱包：': '钱包：',
  '订单状态：': '订单状态：',
  '说明：': '说明：',
  '如有疑问，请联系客服cshw@ijunhai.com':
    '如有疑问，请联系客服cshw@ijunhai.com',
  支付失败: '支付失败',
  购买中: '购买中',
  支付成功: '支付成功',
  购买成功: '购买成功',
  购买失败: '购买失败',
  unknow: 'unknow',
  全部: '全部',
  下拉更新: '下拉更新',
  松开更新: '松开更新',
  更新中: '更新中',
  '加载中……': '加载中……',
  暂无数据: '暂无数据',
  支付完成: '支付完成',
  '请在游戏内查收道具。如需帮助，可以联系我们的客服':
    '请在游戏内查收道具。如需帮助，可以联系我们的客服',
  结束充值: '结束充值',
  '没有记录哦~': '没有记录哦~',
  用户协议: '用户协议',
  隐私协议: '隐私协议',
  '卡号：': '卡号：',
  '密码：': '密码：',
  储值记录: '储值记录',
  '可用余额：': '可用余额：',
  T币: 'T币',
  账号信息: '账号信息',
  '用户ID：': '用户ID：',
  账号注销: '账号注销',
  修改密码: '修改密码',
  旧密码: '旧密码',
  '新密码（6-20位字符）': '新密码（6-20位字符）',
  为了您的账户安全: '为了您的账户安全',
  '请联系客服人员进行再次确认：cshw@iijunhai.com':
    '请联系客服人员进行再次确认：cshw@iijunhai.com',
  确定: '确定',
  立即支付: '立即支付',
  mol: 'Razer',
  游戏账号删除协议: '游戏账号删除协议',
  账号删除进程: '账号删除进程',
  游戏账号删除条件: '游戏账号删除条件',
  '我们为您做出如下特别说明：在删除本游戏的游戏账号后，除法律法规或本协议另有规定外，您在该游戏账号下的个人信息将进行删除或匿名化处理，且此前已关联该游戏账号的相关产品与服务将不再关联。该游戏账号一旦删除完成，将无法恢复，您无法再检索、继续使用、访问和召回，也无权要求我们找回个人信息，请您谨慎操作。前述个人信息包括但不限于头像、昵称、会员权益、等级/经验值等与游戏角色成长升级相关的所有数据、虚拟货币、虚拟道具等虚拟物品、聊天记录等内容。': '我们为您做出如下特别说明：在删除本游戏的游戏账号后，除法律法规或本协议另有规定外，您在该游戏账号下的个人信息将进行删除或匿名化处理，且此前已关联该游戏账号的相关产品与服务将不再关联。该游戏账号一旦删除完成，将无法恢复，您无法再检索、继续使用、访问和召回，也无权要求我们找回个人信息，请您谨慎操作。前述个人信息包括但不限于头像、昵称、会员权益、等级/经验值等与游戏角色成长升级相关的所有数据、虚拟货币、虚拟道具等虚拟物品、聊天记录等内容。',
  '1、账号必须事先绑定邮箱。删除账号需要用邮箱进行验证，确保是本人操作。': '1、账号必须事先绑定邮箱。删除账号需要用邮箱进行验证，确保是本人操作。',
  '2、游戏收益已结清或得到妥善处理：包括但不局限于游戏代币、道具、会员权益等收益。请您妥善处理，若未处理，视为您自愿放弃该等收益。': '2、游戏收益已结清或得到妥善处理：包括但不局限于游戏代币、道具、会员权益等收益。请您妥善处理，若未处理，视为您自愿放弃该等收益。',
  '3、账号无任何纠纷：包括投诉举报、被投诉举报、仲裁、诉讼等纠纷。': '3、账号无任何纠纷：包括投诉举报、被投诉举报、仲裁、诉讼等纠纷。',
  '亲爱的玩家，在您正式开始下一步有关本游戏的删除游戏账号流程前，请您务必先行仔细阅读、充分理解并同意《删除游戏账号协议》（以下统称“本协议”）。您按照游戏内提示的删除游戏账号之操作流程进行删除账号申请或开始删除账号流程的，或者您勾选本删除游戏账号协议并开始下一步操作的，均视为您已经同意和遵守本协议全部内容。': '亲爱的玩家，在您正式开始下一步有关本游戏的删除游戏账号流程前，请您务必先行仔细阅读、充分理解并同意《删除游戏账号协议》（以下统称“本协议”）。您按照游戏内提示的删除游戏账号之操作流程进行删除账号申请或开始删除账号流程的，或者您勾选本删除游戏账号协议并开始下一步操作的，均视为您已经同意和遵守本协议全部内容。',
  有关删除游戏账号的其它详细规则及注意事项请点击查看: '有关删除游戏账号的其它详细规则及注意事项请点击查看',
  删除游戏账号协议: '删除游戏账号协议',
  '将删除的游戏账号：': '将删除的游戏账号：',
  游戏账号: '游戏账号',
  游戏ID: '游戏ID',
  失败原因: '失败原因',
  '亲爱的用户，为确保您的账号安全，请提供您账号绑定的邮箱验证码以供账号删除校验，该验证码仅用于本次验证使用': '亲爱的用户，为确保您的账号安全，请提供您账号绑定的邮箱验证码以供账号删除校验，该验证码仅用于本次验证使用',
  邮箱: '邮箱',
  验证码: '验证码',
  请输入验证码: '请输入验证码',
  获取验证码: '获取验证码',
  请描述你除账号的原因: '请描述你除账号的原因',
  '为防止误操作，请您再次确认是否删除游戏账号并确认删除后的影响，该影响包括但不限于（具体详见：': '为防止误操作，请您再次确认是否删除游戏账号并确认删除后的影响，该影响包括但不限于（具体详见：',
  '1.该账号一旦删除成功，您将无法登录、使用该游戏账号，且无法回复。除法律法规和《删除游戏账号协议》另有约定外，您在该游戏账号下的个人信息将进行删除或匿名化处理，且此前已关联该游戏账号的相关产品与服务将不再关联。该游戏账号一旦删除完成，将无法恢复，您无法再检索、继续使用、访问和召回，也无权要求我们找回个人信息，请您谨慎操作。': '1.该账号一旦删除成功，您将无法登录、使用该游戏账号，且无法回复。除法律法规和《删除游戏账号协议》另有约定外，您在该游戏账号下的个人信息将进行删除或匿名化处理，且此前已关联该游戏账号的相关产品与服务将不再关联。该游戏账号一旦删除完成，将无法恢复，您无法再检索、继续使用、访问和召回，也无权要求我们找回个人信息，请您谨慎操作。',
  '2.您确认知悉，删除游戏账号的，该账号在本游戏使用期间已产生及未来可能产生是所有游戏收益或权益将会被全部删除/清除。据此，也特别提示您，在您开始删除本游戏账号前请您妥善处理您的游戏收益或权益。否则，账号删除后，我们有权利对该账号下的全部收益或权益做删除/清除处理，因此产生的后果由您自行承担，前游戏收益或权益包括但不限于账号内剩余的所有游戏虚拟货币、虚拟道具及其它虚拟物品及增值服务。': '2.您确认知悉，删除游戏账号的，该账号在本游戏使用期间已产生及未来可能产生是所有游戏收益或权益将会被全部删除/清除。据此，也特别提示您，在您开始删除本游戏账号前请您妥善处理您的游戏收益或权益。否则，账号删除后，我们有权利对该账号下的全部收益或权益做删除/清除处理，因此产生的后果由您自行承担，前游戏收益或权益包括但不限于账号内剩余的所有游戏虚拟货币、虚拟道具及其它虚拟物品及增值服务。',
  您的游戏角色将于: '您的游戏角色将于',
  '完成删除。请注意，该账号删除有15日的冷静期(账号锁定期)。除法律法规规定和协议约定情形外 我们将在冷静期满后完成删除，删除或匿名化处理您的个人信息。': '完成删除。请注意，该账号删除有15日的冷静期(账号锁定期)。除法律法规规定和协议约定情形外 我们将在冷静期满后完成删除，删除或匿名化处理您的个人信息。',
  '在此期间，请您不要登录和使用该账号，以确保删除的顺利完成，否则视为您撤销删除申请。': '在此期间，请您不要登录和使用该账号，以确保删除的顺利完成，否则视为您撤销删除申请。',
  确认删除游戏账号: '确认删除游戏账号',
  放弃删除: '放弃删除',
  下一步: '下一步',
  这是个多余的账号: '这是个多余的账号',
  弃游不想再玩: '弃游不想再玩',
  需要解绑邮箱: '需要解绑邮箱',
  需要换绑实名认证信息: '需要换绑实名认证信息',
  其他: '其他',
  我已详细阅读并满足删除账号条件: '我已详细阅读并满足删除账号条件',
  确认删除的游戏账号: '确认删除的游戏账号',
  我已详细阅读并同意: '我已详细阅读并同意',
  验证本账号绑定的邮箱: '验证本账号绑定的邮箱',
  选择删除的原因: '选择删除的原因',
  再次确认是否删除游戏账号并确认删除后的影响: '再次确认是否删除游戏账号并确认删除后的影响',
  删除游戏账号申请提交成功: '删除游戏账号申请提交成功',
  完成: '完成',
  验证码发送成功: '验证码发送成功',
  '请先勾选【我已仔细阅读并满足账号删除条件】': '请先勾选【我已仔细阅读并满足账号删除条件】',
  账号删除申请失败: '账号删除申请失败',
  验证成功: '验证成功',
  请选择删除原因: '请选择删除原因',
  用户的游戏账号未绑定邮箱: '用户的游戏账号未绑定邮箱',
};



// WEBPACK FOOTER //
// ./src/common/lang/zh-cn.js